import { pipe } from 'fp-ts/function';
import * as E from 'fp-ts/Either';
import * as t from 'io-ts';
export function fromUnaryTuple(codec, name) {
    var type = t.tuple([codec]);
    return new t.Type(name !== null && name !== void 0 ? name : "fromUnaryTuple<".concat(codec.name, ">"), codec.is, function (u, c) {
        return pipe(type.validate(u, c), E.map(function (_a) {
            var a = _a[0];
            return a;
        }));
    }, function (a) { return type.encode([a]); });
}
